import { useMemo } from 'react';

import { ICD10Disease } from '@dreryk/egabinet-icd-dictionary-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

export const useDiseaseDefaultItems = (visitDiagnoses: VisitDiagnosis[] | undefined): ICD10Disease[] => {
   return useMemo(() => {
      if (!visitDiagnoses) {
         return [];
      }

      return visitDiagnoses.map<ICD10Disease>((diagnosis) => ({
         code: diagnosis.icd10Code,
         name: diagnosis.name,
      }));
   }, [visitDiagnoses]);
};
